import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { validateFileSize } from 'src/app/utils/common.utils';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { urls } from 'src/app/utils/url.utils';
@UntilDestroy()

@Component({
  selector: 'app-add-levelofservice',
  templateUrl: './add-levelofservice.component.html',
  styleUrls: ['./add-levelofservice.component.css']
})
export class AddLevelofserviceComponent implements OnInit {
  losForm!: FormGroup;
  submitted = false;
  losId:any;
  selectedFile: ImageSnippet | null = null;
  profileImageURL: string | null = null; 

    // Edit Modal Inputs and Outputs
    @Input() levelOfService:any;
    @Input() source:any;
    @Output() onSaveLevelOfService = new EventEmitter<string>();
    @Output() onCloseModal = new EventEmitter<string>();
    // Edit Modal Inputs and Outputs End
  
  
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private losService: LosService,
    private uploadService : UploadService
  ) { }

  ngOnInit(): void {
    if (this.source === 'modal' && this.levelOfService) {
      this.losId = this.levelOfService.id;
      this.getById();
    } else {
      this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
        if (param && param['id']) {
          this.losId = param['id'];
          this.getById();
        }
      });
    }

    this.losForm = this.fb.group({
      title:["", Validators.required],
      description: ["", Validators.required],
      isActive: [true, Validators.required],
      profileImageURL: [""],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.losForm.invalid) {
      return;
    } 
    // this.losForm.patchValue({
    //   profileImageURL : ""
    // })
   
    const payload = this.losForm.value

    this.losService.save(this.losId, payload).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
        if (this.source === 'modal') {
          this.onSaveLevelOfService.emit(data);
        } else {
          this.router.navigateByUrl('/configurations/los')
        }
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");
    }
  )
  }

  getById(){
    this.losService.getById(this.losId).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if(data){
      this.losForm.patchValue({
        ...data
      })
      this.profileImageURL = data.profileImageURL
      }
    })
  }

  processFile(imageInput: any) {
     const file = imageInput.files?.[0];
  if (!validateFileSize(file)) {
        return;
      }
    imageProcessing(imageInput).pipe(untilDestroyed(this)).subscribe({
      next: (result) => {
        this.selectedFile = result.file;
        if (!this.selectedFile || !(this.selectedFile instanceof Blob)) {
          return;
        }
        this.uploadService.uploadImageToServer(this.selectedFile, urls.LEVELOFSERVICE).pipe(untilDestroyed(this)).subscribe({
          next: (uploadResult: any) => {
            if (uploadResult?.fileUrl) {
              this.losForm.get('profileImageURL')?.setValue(uploadResult.fileUrl);
              this.profileImageURL = uploadResult.fileUrl;
            }
          },
        });
      },
      error: (processingError) => {
        console.error('Error processing image:', processingError);
      },
    });
  }

  get form() {
    return this.losForm.controls;
  }
}
